import styled from 'styled-components';
import { Divider } from 'antd';
import { Trans, useTranslation } from 'next-i18next';

import StyledContainer from '@design-system/styled/Container';
import CCPOInspectionPointItem from './CCPOInspectionPointItem';
import { getDataByCountry, KeyPoint } from './content';

const Container = styled(StyledContainer)`
  margin-top: 24px;
  margin-bottom: 84px;
  @media (min-width: 768px) {
    margin-top: 80px;
    margin-bottom: 96px;
  }
`;

const StyledWrapper = styled.div`
  padding: 16px;
  background: #f8f7f7;
  box-shadow: 0px 2px 9px rgb(0 0 0 / 25%);
  border-radius: 12px;
  @media (min-width: 992px) {
    padding: 64px;
  }
`;

const StyledHeading = styled.div`
  margin-bottom: 32px;
  .text-heading {
    ${(props) => props.theme.typo.familyGoogle.bold}
    color: ${(props) => props.theme.color.primaryBase};
    font-size: 28px;
    line-height: 46px;
  }
  .ant-divider {
    margin-top: 16px;
    margin-bottom: 0;
    border-top: 1px solid ${(props) => props.theme.color.primaryBase};
  }

  @media (min-width: 768px) {
    margin-bottom: 40px;
    .text-heading {
      font-size: 38px;
      line-height: 46px;
    }
  }
`;

const StyledContentWrapper = styled.div``;

const CCPOInspectionPointList = () => {
  const data = getDataByCountry();
  const { t } = useTranslation('ccpo');

  return (
    <Container>
      <StyledWrapper>
        <StyledHeading>
          <h1 className="text-heading">
            <Trans ns="ccpo" defaults={t('ccpo.inspectionPointList.heading')} components={{ br: <br /> }} />
          </h1>
          <Divider />
        </StyledHeading>
        <StyledContentWrapper>
          {Object.keys(data).map((key) => (
            <CCPOInspectionPointItem key={key} items={data[key as KeyPoint]} keyPoint={key as KeyPoint} />
          ))}
        </StyledContentWrapper>
      </StyledWrapper>
    </Container>
  );
};

export default CCPOInspectionPointList;
